import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const VoucherReport = () => {
  return <ReportSectionPage scope="org-admin" section="vouchers" title="Voucher Report" />;
};

export default VoucherReport;
